import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment, Zone } from '@domains';

import { BaseApiService } from '../base-api.service';

@Injectable({
  providedIn: 'root',
})
export class ZoneService extends BaseApiService<Zone> {
  constructor(
    @Inject(ENVIRONMENT) override config: Environment,
    override http: HttpClient,
  ) {
    super(config, http, 'zones', Zone, 'Zone');
  }
}
